"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_NAME = void 0;
const COPY_1 = require("../../../global/ui/messages/COPY.js");
const COPY_2 = require("../../../global/ui/placeholders/COPY.js");
exports.COMPANY_NAME = {
    MIN_LENGTH: 1,
    PATTERN: /^[a-zA-Z0-9 ]+$/u,
    PLACEHOLDER: COPY_2.PLACEHOLDERS_COPY.COMPANY_NAME,
    REQUIRED_MESSAGE: COPY_1.MESSAGES_COPY.PLEASE_ENTER_YOUR_COMPANY_NAME
};
//# sourceMappingURL=COMPANY_NAME.js.map